import { render } from "./OrgTransferDetailPage.vue?vue&type=template&id=2312b210&scoped=true"
import script from "./OrgTransferDetailPage.vue?vue&type=script&lang=js"
export * from "./OrgTransferDetailPage.vue?vue&type=script&lang=js"

import "./OrgTransferDetailPage.vue?vue&type=style&index=0&id=2312b210&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2312b210"]])

export default __exports__